/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { startCourse } from 'store/modules/course_store/actions';
import { Container } from './styles';

const ModalWelcomeIaml = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState<boolean>(true);

  useEffect(() => {
    setShowModal(!hasCookie('modalWelcomeIaml'));
  }, []);

  useEffect(() => {
    if (!showModal) setCookie('modalWelcomeIaml', true);
  }, [showModal]);

  const handleClick = () => {
    dispatch(startCourse(2));
  };

  return (
    <Modal className="align-items-center" show={showModal}>
      <Container>
        <div>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Boas-vindas ao ConLicitação!</h5>
            </div>
            <div className="modal-body">
              <iframe
                title="monitoramento-video"
                id="video"
                width="100%"
                height="262"
                src="https://player.vimeo.com/video/982691833"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" onClick={() => handleClick()}>
                Começar curso
              </button>
              <button type="button" className="btn btn-link" onClick={() => setShowModal(false)}>
                Usar a plataforma
              </button>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalWelcomeIaml;
